import { createContext, useContext, useState } from 'react';

type State = { showP1Content: boolean; page: number };
export const HomePageStateContext = createContext({} as State);
export const HomePageActionContext = createContext({} as any);
export const HPTriggerActionContext = createContext({} as (_: boolean) => void);

interface Props {
    children: React.ReactNode;
}

export default function HomePageProvider({ children }: Props) {
    const [showP1Content, setShowP1Content] = useState(false);
    const [page, setPage] = useState(0);

    return (
        <HPTriggerActionContext.Provider value={setShowP1Content}>
            <HomePageActionContext.Provider value={setPage}>
                <HomePageStateContext.Provider value={{ showP1Content, page }}>
                    {children}
                </HomePageStateContext.Provider>
            </HomePageActionContext.Provider>
        </HPTriggerActionContext.Provider>
    );
}

export const useHomePageState = () => {
    return useContext(HomePageStateContext);
};

export const useHomePageAction = () => {
    return useContext(HomePageActionContext);
};
export const useHomePageTriggerAction = () => {
    return useContext(HPTriggerActionContext);
};
